import { Link } from "react-router-dom";

interface CategoryCardProps {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export default function CategoryCard({
  slug,
  name,
  description,
  icon,
  articleCount,
}: CategoryCardProps) {
  return (
    <Link
      to={`/category/${slug}`}
      className="group flex flex-col items-center text-center p-6 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-200/70 hover:bg-primary-50/30 transition-all duration-300"
    >
      <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-primary-100/70 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 mb-4">
        <i className={`${icon} text-2xl`}></i>
      </div>
      <h3 className="font-heading text-base font-bold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
        {name}
      </h3>
      <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">
        {description}
      </p>
      <span className="text-xs text-primary-500 bg-primary-100/60 px-3 py-0.5 rounded-full font-medium whitespace-nowrap">
        {articleCount} 篇文章
      </span>
    </Link>
  );
}